///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API } from "../api/axios";

export const getBidMessages = bidId => {
  return API.get("api/v1.0/messages", {
    params: {
      bidId
    }
  });
};

export const postUserMessage = userMessageRequest => {
  return API.post("api/v1.0/messages", userMessageRequest);
};
